import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FieldItem } from '@april9/stack9-sdk';
import cx from 'classnames';

import FieldLabel from './FieldLabel';

type Props = {
  name: string;
  defaultValue: any;
  fieldItem: FieldItem;
};

const ColorPickerField = ({ name, defaultValue = '', fieldItem }: Props) => {
  const [hasColor, setHasColor] = useState(!!defaultValue);
  const {
    formState: { errors },
    control,
  } = useFormContext();
  const placeholder = fieldItem?.placeholder;
  const readOnly = fieldItem.ui_component_options?.readOnly || false;
  const colorInputProps = {
    name: `color-${name}`,
    className: 'form-control',
    placeholder,
    id: name,
    readOnly,
  };

  const inputTextProps = {
    className: 'form-control',
    placeholder,
    id: `text-${name}`,
    readOnly,
  };

  return (
    <FieldLabel fieldItem={fieldItem}>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field }) => {
          return (
            <div
              id={`field-${name}`}
              className={cx(
                'd-flex align-items-center form-control overflow-hidden',
                { 'is-invalid': errors[name] },
              )}
            >
              <input
                type="text"
                {...inputTextProps}
                value={hasColor ? field.value : ''}
                onChange={({ target: { value } }) => {
                  setHasColor(!!value);
                  field.onChange(value || '');
                }}
              />
              {hasColor && (
                <button
                  className="close"
                  onClick={() => {
                    setHasColor(false);
                    field.onChange('');
                  }}
                >
                  <span aria-hidden="true">×</span>
                  <span className="sr-only">Close</span>
                </button>
              )}
              <input
                type="color"
                {...colorInputProps}
                value={field.value}
                style={{ width: '50px' }}
                onChange={({ target: { value } }) => {
                  setHasColor(!!value);
                  field.onChange(value || '');
                }}
              />
            </div>
          );
        }}
      />
      {fieldItem.description && (
        <small className="form-text text-muted">{fieldItem.description}</small>
      )}
    </FieldLabel>
  );
};

export default ColorPickerField;
